import { toast } from './useToast';

/** The message the API sent with a failed request, if any. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as any)?.response?.data;
  const message = data?.message ?? data?.error;
  if (Array.isArray(message) && message.length > 0) return message.join(', ');
  if (typeof message === 'string' && message.trim()) return message;
  return fallback;
}

/** Shows a failed request to the user as an error toast. */
export function notifyError(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
) {
  toast({ variant: 'error', title: apiErrorMessage(error, fallback) });
}
